<div style="min-height: 580px;">
    <div class="d-flex" style="margin-top: 10px; font-family: OpenSansHebrewBold">
    <div class=" d-flex m-auto " style="width: 74.5%; direction: rtl; font-weight: bold; font-size: 18px;">
        <span class="col-6" style="text-align: right;" >ההזמנה שלך</span>
        <span  class="col-6" >{{totalPrice}} ₪</span>
    </div>
    </div>
    <div *ngIf="isDelivery==1 " class="d-flex" style="margin-top: 10px; font-family: OpenSansHebrewBold">
    <div class=" d-flex m-auto " style="width: 74.5%; direction: rtl; font-weight: bold; font-size: 18px;">
        <span class="col-6" style="text-align: right;" >דמי משלוח</span>
        <span  class="col-6" >{{deliveryPrice}} ₪</span>
    </div>
    </div>
     <div *ngIf="TotalVat!='0'" class="d-flex" style="margin-top: 10px; font-family: OpenSansHebrewBold">
    <div class=" d-flex m-auto " style="width: 74.5%; direction: rtl; font-weight: bold; font-size: 18px;">
        <span class="col-6" style="text-align: right;" >מע״מ</span>
        <span  class="col-6" >{{order.TotalVat}} ₪</span>
    </div>
    </div>
    <div *ngIf="isDelivery==1 " class="d-flex" style="margin-top: 10px; font-family: OpenSansHebrewBold">
        <div class=" d-flex m-auto " style="width: 74.5%; direction: rtl; font-weight: bold; font-size: 18px;">
            <span class="col-6" style="text-align: right;" >סה״כ</span>
            <span  class="col-6" >{{balance}} ₪</span>
        </div>
        </div>
    <div class="d-flex"  style="margin-top: 10px; margin-bottom: 10px;" >
        <img class="m-auto" style="width: 73%; " src="assets/images/Pay_Page_Line.png">
    </div>

   
    <div class="container" style="height: 40%; font-size: 14px; font-family: OpenSansHebrewRegular">
        <div *ngIf="inCash==true"   class="d-flex m-auto" style="direction: rtl; text-align: right; font-family: OpenSansHebrewBold">
            <div class="col-5" style="font-size: 14px;">
   
                <span  style="font-weight: bold;">תשלום במזומן</span>
                </div>
        <div  class="align-self-center">
            <img (click)="cashPayment()" style="cursor: pointer;background-size: contain;" [src]="cashPaymentImg">
        </div>
        </div>
       
        <div *ngIf="onCredit==true"  class="d-flex" style="direction: rtl; text-align: right; font-family: OpenSansHebrewBold ; margin-top: 10px;">
            <div class="col-5" style="font-size: 14px;"> 
                <span style="font-weight: bold; " >תשלום באשראי</span>
                </div>
        <div  class="align-self-center">
            <img (click)="creditPayment()" style="cursor: pointer;background-size: contain;" [src]="paymentCreditImg">
        </div>
       
        </div>

        <mat-spinner *ngIf="showProgress==true" class="mat-spinner-color" style=" justify-content: center; 
        align-items: center; margin:0 auto;" [diameter]="70" mode="indeterminate"></mat-spinner>
        <div>
           
        <form  class="form-signin" [formGroup]="paymentForm" style="font-family: OpenSansHebrewRegular; margin-right: 3px;">
    <div class="bg-img d-flex">
        <div *ngIf="isCreditPayment==true" class="col-6" style="margin-right: 7px;">
        <div >
       <div class="d-flex">     
    <span style="margin-bottom: 5px; padding-right: 2px;">שם בעל הכרטיס</span>
       </div>
       <div class="d-flex">
        <input #firstInput autocomplete="off"  matInput formControlName="nvCardholderName" 
        (keydown.enter)="focusNext(nvCardNumber)"
        [ngClass]="!isValidInput('nvCardholderName') ? 'input-street' : 'input-street-error' " type="text" required>
    </div>
    </div>
    <div>
    <div class="d-flex" style="margin-bottom: 5px; margin-top: 5px;">
    <span class="col-6" style=" padding-right: 2px;">מספר הכרטיס</span>
    </div>
    
    <div class="d-flex"> 
        <input #nvCardNumber autocomplete="off"  matInput formControlName="nvCardNumber"  [ngClass]=" !isValidInput('nvCardNumber') ? 'input-street' : 'input-street-error' " 
        (keydown.enter)="focusNext(month)"
        required  appCardNumberFormatter dir="ltr">
        
    </div>
    </div>
    <div style="margin-top: 5px;">
        <div class="d-flex">
            <span class="col-6" style="padding-right: 2px;">תוקף</span>
            <span>cvv</span>
            </div>
                              

                <div style="display: flex">   
                    <div class="d-flex">
                        <input #year inputmode="numeric" pattern="[0-9]*" type="tel" placeholder="yy" style="margin-right: 3px;" (click)="clearYear()"  
                     [ngClass]=" !isValidInput('year') ? 'box2' : 'box-error' " formControlName="year"/> 
                      <input #month inputmode="numeric" pattern="[0-9]*" type="tel" placeholder="MM" style="margin-right: 3px;"
                      [ngClass]=" !isValidInput('month') ? 'box2' : 'box-error' " formControlName="month" (click)="clearMonth()"/> 
                      </div>
                      <input #cvv inputmode="numeric" pattern="[0-9]*" type="tel" style="margin-right: 3px;" 
                      name="methodsPayment.card_cvv" [ngClass]=" !isValidInput('cvv') ? 'box2' : 'box-error' " required formControlName="cvv"/> 
                    </div> 
</div>
<div class="d-flex">     
<span style="margin-bottom: 5px; padding-right: 2px;">מספר תעודת זהות של בעל הכרטיס</span>
   </div>
   <div class="d-flex">
    <input #identity autocomplete="off"  matInput formControlName="identityNumber" [ngClass]="!isValidInput('identityNumber') ? 'input-street' : 'input-street-error' " 
    type="text" required  (keydown.enter)="focusNext(nvOrderName)">
</div>  
   
    </div>
    <br>
    <span *ngIf="paymentForm.valid==false"  style="color: #ff8585; bottom: -40px; position: absolute;">יש להזין את כל פרטי החובה</span>
    <div class="col-6" style="margin-right: 7px;">
        <div >
       <div class="d-flex">     
    <span style="margin-bottom: 5px; padding-right: 2px;">שם המזמין</span>
       </div>
       <div class="d-flex">
        <input #nvOrderName matInput formControlName="nvOrderName" [ngClass]="!isValidInput('nvOrderName') ? 'input-street' : 'input-street-error' " (keydown.enter)="onNvOrderNameEnter()" required>
    </div>
    </div>
    <div *ngIf="IsDelivery==1">
    <div  class="d-flex" style="margin-bottom: 5px;
    margin-top: 5px;">
    <span class="col-6" style=" padding-right: 2px;">כתובת</span>
    </div>
  
    
    <div class="d-flex">     
        <div class="map-container" >
            <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
              <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
            </agm-map>
          </div>   
          <input #nvStreet *ngIf="IsDelivery==1" #search id="pac-input" matInput formControlName="nvStreet" [ngClass]="!isValidInput('nvStreet') ? 'input-street' : 'input-street-error' " required   (keydown.enter)="focusNext(nvEntry)"> 
          <input *ngIf="IsDelivery==0" #search id="pac-input" matInput formControlName="nvStreet" class="input-street"   (keydown.enter)="focusNext(nvEntry)">             
        </div> 
    </div>
    <div *ngIf="IsDelivery==1">
        <div class="d-flex" style="margin-bottom: 5px; margin-top: 5px;">
            <span class="col-4" style="padding-right: 2px;">כניסה</span>
            <span class="col-4">קומה</span>
            <span class="col-4">דירה</span>
            </div>
            <div class="d-flex">
                <input #nvEntry matInput formControlName="nvEntry" style="margin-left: 25px;" (keydown.enter)="focusNext(nvfloor)" 
                  class="input-street"  type="text">
                <input #nvfloor matInput formControlName="nvfloor" style="margin-left: 25px;" (keydown.enter)="focusNext(nvNumberHoush)" 
                class="input-street" type="number">
                <input #nvNumberHoush matInput formControlName="nvNumberHoush" (keydown.enter)="focusNext(nvPhone)" 
                class="input-street"  type="number">     
            </div>
            </div>
    <div class="d-flex" style="margin-top: 5px;">     
        <span style="margin-bottom: 5px; padding-right: 2px;">טלפון</span>
           </div>
           <div class="d-flex">

            <input #nvPhone matInput minlength="10" maxlength="10" formControlName="nvPhone" (keydown.enter)="focusNext(nvEmail)"
            [ngClass]="!isValidInput('nvPhone') ? 'input-street' : 'input-street-error'" type="tel" required >
        </div>
<div class="d-flex" style="margin-top: 5px;">     
<span style="margin-bottom: 5px; padding-right: 2px;">אימייל</span>
   </div>
   <div class="d-flex">
    <input #nvEmail matInput formControlName="nvEmail" [ngClass]="!isValidInput('nvEmail') ? 'input-street' : 'input-street-error' " type="email">
</div>  

<div *ngIf="isCreditPayment==true" class="d-flex" style="direction: rtl; text-align: right; font-family: OpenSansHebrewBold ; margin-top: 10px;">
    <div class="col-5" style="font-size: 14px;"> 
        <span style="font-weight: bold; " >תשלום מאובטח</span>
        </div>
<div  class="align-self-center">
    <img (click)="isCreditSecureClick()" style="cursor: pointer;background-size: contain;" [src]="isCreditSecureImg">
</div>

</div>
    </div>
    </div>
    </form> 
    </div>
         <div class="keep" [class.isDisabled]="paymentForm.valid">
        <img *ngIf="paymentForm.valid==true" src="assets/images/Delivery_Popup_Ok_Button.png">  
        <img *ngIf="paymentForm.valid==false" src="assets/images/Delivery_Popup_Cancel_Button.png"> 
                   
        <span  (click)="payment()" class="d-flex btn" style="justify-content:space-around; align-items: center; align-content: center; font-size: 14px; font-family: OpenSansHebrewRegular;  width: 300px; color: rgb(255, 255, 255);" [ngStyle]="paymentForm.valid==false && {'color':'#29c067'}">
            <span style=" margin-right: 20px; "> המשך לתשלום</span>
                <span style="margin-left: 20px;">{{balance}} ₪</span>

        </span>
      </div>
    </div>
    </div>
    

   
  
    